"use strict";

import { isEmpty } from "lodash";
import constants from "../constants";
import { populateFieldErrors, populateErrorMessage, populateErrorMessageWithHtml, invalidFieldMessage, clearFieldErrorMessage } from "../helpers/formHelpers";

const initFormListHelper = () => {
    console.log("lisHelper.js loaded");
    const tabList         = $(".js-form-list-helper-tab");

    tabList.each((index, headerTab) => {

        $(headerTab).on("click", () => {
            console.log("Header tab clicked: ", headerTab);
            const newActiveTabID = $(headerTab).attr("id");

            $(".js-form-list-helper-tab").removeClass("active");
            $("#" + newActiveTabID).addClass("active");

            $(".list-helper-form").addClass("d-none");
            $("#"+newActiveTabID+"-data-form").removeClass("d-none");
        });

        $(headerTab).on("keypress", (event) => {
            if (event.keyCode === constants.KEYBOARD_KEYS.ENTER) {
                $(headerTab).trigger("click");
            }
        });

    });

    const formCpf              = $("#cpf-data-form");
    const urlCpf               = formCpf.attr("action");
    const cpfFormButton         = $("#cpf-form-button");
    cpfFormButton.on("click", (event) => {
        event.preventDefault();
        cpfFormButton.toggleClass("btn-primary").toggleClass("btn-primary-loading");
        const formData  = formCpf.serializeArray();
        try {
            if(validateForm(formCpf)){
                const name      = formData.find(item => item.name === "cpf-form-name").value.trim();
                const lastname  = formData.find(item => item.name === "cpf-form-lastname").value.trim();
                const locality  = formData.find(item => item.name === "cpf-form-city").value.trim();

                $.ajax({
                url: urlCpf,
                type: "POST",
                data: JSON.stringify({
                    "name": lastname ? name + " " + lastname : name,
                    "locality": locality
                }),
                contentType: "application/json",
                success: function (response) {
                    cpfFormButton.toggleClass("btn-primary").toggleClass("btn-primary-loading");
                    const phoneList = response.phoneList;
                    $("#content-results").removeClass("d-none");
                    const phoneListTable = $("#phone-list-table");
                    const phoneListCards = $("#card-content");
                    phoneListTable.empty();
                    phoneListCards.empty();

                    if (phoneList && phoneList.length > 0) {
                        phoneListTable.append(`<thead><tr>
                            <th scope="col">Nome</th>
                            <th scope="col">Telefone</th>
                            <th scope="col">Endereço</th>
                        </tr></thead>`);
                        phoneListTable.append("<tbody>");
                        phoneList.forEach((item) => {
                            const row = `<tr>
                                <td>${item.nameFiguration102}</td>
                                <td>${formatPhoneNumber(item.phoneNumber)}</td>
                                <td>${item.addressDescription}</td>
                            </tr>`;
                            phoneListTable.append(row);

                            const card = `<div class="card">
                                <div>${item.nameFiguration102}</div>
                                <div>${formatPhoneNumber(item.phoneNumber)}</div>
                                <div>${item.addressDescription}</div>
                            </div>`
                            phoneListCards.append(card);
                        });
                        phoneListTable.append("</tbody>");
                    } else {
                        phoneListTable.append("<tr><td colspan='3'>Sem resultados</td></tr>");
                        phoneListCards.append(`<div class="card">
                                <div>Sem resultados</div>
                            </div>`);
                    }
                },
            error: function (error) {
                cpfFormButton.toggleClass("btn-primary").toggleClass("btn-primary-loading");
                console.error("Error occurred: ", error);
            }
        }); 
            }else{
                cpfFormButton.toggleClass("btn-primary").toggleClass("btn-primary-loading");
            }        
        } catch (error) {
            cpfFormButton.toggleClass("btn-primary").toggleClass("btn-primary-loading");
            console.log(error)
        }
        
    });

    const form              = $("#cnpj-data-form");
    const url               = form.attr("action");
    const cnpjFormButton    = $("#cnpj-form-button");
    cnpjFormButton.on("click", (event) => {
        event.preventDefault();
        cnpjFormButton.toggleClass("btn-primary").toggleClass("btn-primary-loading");
        const formData = form.serializeArray();        
        if(validateForm(form)){
            const name = formData.find(item => item.name === "cnpj-form-name").value.trim();
            const locality = formData.find(item => item.name === "cnpj-form-city").value.trim();
            $.ajax({
                url: url,
                type: "POST",
                data: JSON.stringify({
                    "name": name,
                    "locality": locality
                }),
                contentType: "application/json",
                success: function (response) {
                    cnpjFormButton.toggleClass("btn-primary").toggleClass("btn-primary-loading");
                    $("#content-results").removeClass("d-none");
                    const phoneList = response.phoneList;
                    const phoneListTable = $("#phone-list-table");
                    const phoneListCards = $("#card-content");
                    console.log('cardd', phoneListCards);
                    phoneListTable.empty();
                    phoneListCards.empty();

                    if (phoneList && phoneList.length > 0) {
                        phoneListTable.append(`<thead><tr>
                            <th scope="col">Nome</th>
                            <th scope="col">Telefone</th>
                            <th scope="col">Endereço</th>
                        </tr></thead>`);
                        phoneListTable.append("<tbody>");
                        phoneList.forEach((item) => {
                            const row = `<tr>
                                <td>${item.nameFiguration102}</td>
                                <td>${formatPhoneNumber(item.phoneNumber)}</td>
                                <td>${item.addressDescription}</td>
                            </tr>`;
                            phoneListTable.append(row);

                            const card = `<div class="card">
                                <div>${item.nameFiguration102}</div>
                                <div>${formatPhoneNumber(item.phoneNumber)}</div>
                                <div>${item.addressDescription}</div>
                            </div>`
                            phoneListCards.append(card);
                        });
                        phoneListTable.append("</tbody>");
                    } else {
                        phoneListTable.append("<tr><td colspan='3'>Sem resultados</td></tr>");
                    }
                },
                error: function (error) {
                    cnpjFormButton.toggleClass("btn-primary").toggleClass("btn-primary-loading");
                    console.error("Error occurred: ", error);
                }
            });
        }else{
            cnpjFormButton.toggleClass("btn-primary").toggleClass("btn-primary-loading");
        }
        
    });
};

const validateForm = (form) => {
    let isValid = true;
    form.find("input").each(function () {
        const $input = $(this);
        if (isEmpty($input.val())) {
            $input.addClass("is-invalid").removeClass("success");
            $input.closest(".form-group").find(".invalid-feedback").text('Campo obrigatório.');
            isValid = false;
        } else {
            clearFieldErrorMessage($input);
        }
    });
    return isValid;
}

const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return "";
    if(phoneNumber.length === 10) {
        const cleaned = ("" + phoneNumber).replace(/\D/g, "");
        const match = cleaned.match(/^(\d{2})(\d{4})(\d{4})$/);
        if (match) {
            return `(${match[1]}) ${match[2]}-${match[3]}`;
        }
        return phoneNumber;
    }else if(phoneNumber.length === 11) {
        const cleaned = ("" + phoneNumber).replace(/\D/g, "");
        const match = cleaned.match(/^(\d{2})(\d{5})(\d{4})$/);
        if (match) {
            return `(${match[1]}) ${match[2]}-${match[3]}`;
        }
        return phoneNumber;
    } else {
        return phoneNumber;
    }
    
};

const initListHelper = () => {
    initFormListHelper();
};

export default initListHelper;
